import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ManageHub } from '../../../../services/manage-hub';
import { UserService } from '../../../../services/user-service';

import { Directory, CcsFile } from '../../../../models/hub';

import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ScrollingModule } from '@angular/cdk/scrolling';


@Component({
  selector: 'app-manage-documents',
  imports: [
    DatePipe,
    MatIconModule,
    MatTreeModule,
    MatButtonModule,
    MatCardModule,
    ScrollingModule
  ],
  templateUrl: './manage-documents.html',
  styleUrl: './manage-documents.css'
})
export class ManageDocuments implements OnInit {

  constructor(
    private _hubService: ManageHub,
    private _userService: UserService,
  ) { }


  public documentsTree: Directory | null = null;
  public dataSource: Directory[] = [];
  public nodeFiles: CcsFile[] = [];
  public selectedNode: Directory | null = null;
  public childrenAccessor = ( node: Directory ) => node.subdirectories ?? [];
  public userHubId: string = '';
  public hasChild = ( _: number, node: Directory ) => !!node.subdirectories;

  async ngOnInit(): Promise<void>
  {
    this.userHubId = this._userService.getUser()?.hubId || '';
    this.documentsTree = await this._hubService.getDocumentsTree( this.userHubId );
    this.dataSource = this.documentsTree.subdirectories ?? [];
    this.nodeFiles = this.documentsTree.ccsFiles ?? [];
  }

  async getNodeFiles( node: Directory ): Promise<void>
  {    
    this.selectedNode = node;
    this.nodeFiles = node.ccsFiles ?? [];
  }

}
